<template>
  <div>
    <span class="caption">Dark theme</span>
    <StatusSwitch @change="toggleTheme">
      <span slot="true" class="body-2">On</span>
      <span slot="false" class="body-2">Off</span>
    </StatusSwitch>
  </div>
</template>

<script>
export default {
  components: {
    StatusSwitch: () => import('@/components/StatusSwitch')
  },
  methods: {
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.theme = this.$vuetify.theme.dark
    }
  }
}
</script>
